// extracted by mini-css-extract-plugin
module.exports = {"addStaff_box":"AddStaff_addStaff_box__1NvlA","addStaff_field":"AddStaff_addStaff_field__1r-rO","addStaff_title":"AddStaff_addStaff_title__1hVEJ"};